import { useEffect, useState, Component } from "react";
import { AnimatePresence } from "framer-motion";
import Lenis from "lenis";
import "@/App.css";
import Loader from "@/components/Loader";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import InfoBar from "@/components/InfoBar";
import About from "@/components/About";
import Marquee from "@/components/Marquee";
import MenuSection from "@/components/MenuSection";
import Specialties from "@/components/Specialties";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="min-h-screen bg-cocoa-950 text-cream flex items-center justify-center p-8 text-center font-sans">
          Something went wrong. Please refresh the page.
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const timer = setTimeout(() => setLoading(false), 1100);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = loading ? "hidden" : "";
  }, [loading]);

  return (
    <ErrorBoundary>
      <div className="bg-cocoa-950 text-cream font-sans min-h-screen">
        <AnimatePresence>{loading && <Loader />}</AnimatePresence>
        <div className="grain" aria-hidden="true" />
        <Navbar />
        <main>
          <Hero />
          <InfoBar />
          <About />
          <Marquee />
          <MenuSection />
          <Specialties />
          <Contact />
        </main>
        <Footer />
      </div>
    </ErrorBoundary>
  );
}

export default App;
